module.exports = __webpack_public_path__ + "static/media/travolta-crunched.2ea66c06.gif";